module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/gameboy-146e4a3e833d45a117ba6467d657625e.svg";